module.exports = __webpack_public_path__ + "static/media/infulzMobile.47000fb6.webp";